import * as React from 'react';
import { CaseResult } from 'app/area/case-report/case-listing/types-store';
import { BowtieListingResultList } from './bowtie-listing-result-list';
import { FavouriteDefinition } from 'app/types-shared';
import { CaseReportListingInformation } from 'app/area/case-report/components/case-report-listing-information';

interface BowtieListingResultOrInfoProps {
  translation: any;
  autoExecute: boolean;
  results?: CaseResult[];
  fetching: boolean;
  workingDefinition: FavouriteDefinition;
  shouldPaginate: boolean;
  maxOptionsPerPage: number;
  currentPage: number;
  numberOfPages: number;
  first: any;
  previous: any;
  next: any;
  last: any;
}

export const BowtieListingResultOrInfo = ({
  translation, 
  autoExecute,
  results,
  fetching,
  workingDefinition,
  shouldPaginate,
  maxOptionsPerPage,
  currentPage,
  numberOfPages,
  first,
  previous,
  next,
  last
}: BowtieListingResultOrInfoProps) => {
 
  if (autoExecute) {
    return <BowtieListingResultList
      translation={translation}
      results={results}
      fetching={fetching}
      workingDefinition={workingDefinition}
      maxOptionsPerPage={maxOptionsPerPage}
      numberOfPages={numberOfPages}
      shouldPaginate={shouldPaginate}
      currentPage={currentPage}
      first={first}
      previous={previous}
      next={next}
      last={last}
    />;
  }
  return <CaseReportListingInformation 
    translation={translation} />;
};
